"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setEvents = setEvents;
var _ramda = require("ramda");
/** Отключает все ивенты, если график одной линии (оценка) и десктоп */
function setEvents(cfg, props) {
  if (props.eachPointAnnotation && props.isDesktop) {
    const lens = (0, _ramda.lensPath)(['events']);
    cfg.options = (0, _ramda.set)(lens, [], cfg.options);
  }
}